import { loader } from 'graphql.macro'

export default function invoiceQuery ({ dataLoaders, queryKey }) {
  const [, id] = queryKey

  const invoiceSchema = loader('./invoice.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(invoiceSchema, { id })
}
